import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { generateQueryString } from 'src/util/helper';

enum AdditiveServiceEnum {
  base = '/'
}

export class AdditiveService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/additive");
  }

  public reprocess = (id: number): Promise<void> => this.POST(`${AdditiveServiceEnum.base}?${generateQueryString({ id })}`)
}